import React from 'react';
import PropTypes from 'prop-types';
import CDPInfoFactory from '../../CDPInfoFactory';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../constants/text';
import { colors } from '../../../../constants/colors';
import ClinicLogo from './ClinicLogo';
import CustomDescription from '../../CDPInfoFactory/CustomDescription';

const StyledImg = styled.img`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
`;

const DescriptionContainer = styled.div`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueMonday};
  line-height: 21px;

  a,
  a:link,
  a:visited,
  a:focus,
  a:hover,
  a:active {
    color: ${colors.blueMonday};
    text-decoration: underline;
  }
`;

const StyledClinicLogo = styled(ClinicLogo)`
  max-width: 91px;
  height: 91px;
  padding: 5px;
  border: 1px solid ${colors.greyHounds};
  margin-right: 23px;
  margin-bottom: 23px;
  float: left;
`;

const DescriptionWithLogo = props => {
  const { location, nearbyLocations, className, clinicDescriptionOnly, userAgent } = props;

  const CDPInfo = CDPInfoFactory.buildFromLocation(location, nearbyLocations, { userAgent });

  const content = clinicDescriptionOnly ? (
    <CustomDescription location={location} />
  ) : (
    CDPInfo.getBody()
  );

  return (
    <DescriptionContainer className={className}>
      <StyledClinicLogo location={location} customImgTag={StyledImg} />
      {content}
    </DescriptionContainer>
  );
};

DescriptionWithLogo.propTypes = {
  location: PropTypes.object.isRequired,
  className: PropTypes.string,
  clinicDescriptionOnly: PropTypes.bool,
  nearbyLocations: PropTypes.object,
  userAgent: PropTypes.string,
};

export default DescriptionWithLogo;
